import {webRequest, webNoTokenRequest} from '../api'

// 記帳本列表
export function getLedgerList(params) {
    return webRequest({
        url:'/v1/oauth/management/ledger/getData',
        method:'get',
        params: params,
    })
}
// 取得記帳項目
export function getLedgerItem(params) {
    return webRequest({
        url:'/v1/oauth/management/ledger/item',
        method:'get',
        params: params,
    })
}
// 取得記帳明細
export function getLedgerDetail(params) {
    return webRequest({
        url:'/v1/oauth/management/ledger/detail',
        method:'get',
        params: params,
    })
}
// 新增記帳本
export function insertLedger(data) {
    return webRequest({
        url:'/v1/oauth/management/ledger/add',
        method:'post',
        data: data,
    })
}
// 編輯記帳本
export function updateLedger(data) {
    return webRequest({
        url:'/v1/oauth/management/ledger/update',
        method:'post',
        data: data,
    })
}// 刪除記帳本
export function deleteLedger(data) {
    return webRequest({
        url:'/v1/oauth/management/ledger/delete',
        method:'post',
        data: data,
    })
}



// WEBPACK FOOTER //
// ./src/apis/company/ledger.js